import React from 'react';

function Home() {
  return (
    <div>
      <h1>Welcome to Inovaantage</h1>
      <p>This is the homepage. Click Contact → Our Offices to view office locations.</p>
    </div>
  );
}

export default Home;

